import seoConfig from './seoConfig'
import seoConfigSST from './seoConfigSST'

export type seoConfigProps = typeof seoConfig

export { default as Images } from './Images'
export { default as Routes } from './Routes'
export { default as Main } from './Main'
export { default as SpecificModules } from './SpecificModules'

export { seoConfig }
export { seoConfigSST }
